// Anveshan Society Logo — an abstract compass rose in Terracotta on cream
export default function Logo({ size = 36, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <linearGradient id="anv-g" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#D95A41" />
            <stop offset="100%" stopColor="#B84A34" />
          </linearGradient>
        </defs>
        {/* outer circle */}
        <circle cx="24" cy="24" r="22" fill="url(#anv-g)" />
        {/* petal / diya shape */}
        <path d="M24 6 L28 22 L24 42 L20 22 Z" fill="#F9F6F0" opacity="0.95" />
        <path d="M6 24 L22 20 L42 24 L22 28 Z" fill="#F9F6F0" opacity="0.55" />
        {/* center dot */}
        <circle cx="24" cy="24" r="3" fill="#2C4A3B" />
      </svg>
      {showText && (
        <span className="font-heading text-xl sm:text-2xl tracking-tight text-[#1C1B1A] leading-none">Anveshan</span>
      )}
    </div>
  );
}
